import { Box, Link } from "@mui/material";
import { Button } from "@samdesk/components/Button";
import { Form } from "@samdesk/components/Form";
import { InputEmail } from "@samdesk/components/InputEmail";
import { Stack } from "@samdesk/components/Stack";
import { Text } from "@samdesk/components/Text";
import { Link as RouterLink } from "react-router-dom";

import { messageSx, linkSx, wrapperSx } from "router/authStyles";
import useController from "./useController";

const Index = () => {
	const { emailMismatchError, errorMessage, handleSubmit, misconfiguredError } =
		useController();

	/** this is a unique endpoint that has to be form submitted */
	return (
		<Box sx={wrapperSx}>
			<Stack spacing="large">
				<Form onSubmit={handleSubmit}>
					<Stack spacing="large">
						<Stack spacing="base">
							<InputEmail
								autoComplete="email"
								label="Email"
								name="email"
								rules={{ required: "Email is required" }}
							/>

							{/* display error message as is from url */}
							{errorMessage && (
								<Box sx={messageSx}>
									<Text accent="error">{errorMessage}</Text>
								</Box>
							)}

							{/* custom error message from a url param */}
							{emailMismatchError && (
								<Box sx={messageSx}>
									<Stack alignItems="center" spacing="none">
										<Text accent="error">
											There was an email mismatch between what you requested and
											what your identity provider returned.
										</Text>
										<Text accent="error">
											Please ensure that the email you provide is the same one
											you use to log into your identity provider.
										</Text>
									</Stack>
								</Box>
							)}

							{/* custom error message from a url param */}
							{misconfiguredError && (
								<Box sx={messageSx}>
									<Stack alignItems="center" spacing="none">
										<Text accent="error">
											It looks like your SSO integration is misconfigured.
										</Text>
										<Text accent="error">
											Please contact your account administrator for assistance.
										</Text>
									</Stack>
								</Box>
							)}
						</Stack>
						<Button
							fullWidth
							label="Sign in with SSO"
							prominence="primary"
							submit
						/>
					</Stack>
				</Form>
				<Stack alignItems="center">
					<Link
						component={RouterLink}
						sx={linkSx}
						to="/signin"
						underline="none"
					>
						Sign in with email/password
					</Link>
				</Stack>
			</Stack>
		</Box>
	);
};

export default Index;
